import { ParserAbstraction } from "./parser.abstraction";
import { ParserFunctionType } from "../parser.type";
import { KeyStoreModel } from "@bitwarden/web-vault/app/models/store/key.store.model";

export class KeyParser extends ParserAbstraction {
  override getParser(version: number): ParserFunctionType {
    if (!this.isSupportedVersion(version)) {
      throw new Error(`Unsupported Key parser version ${version}`);
    }

    switch (version) {
      case 0:
        return KeyParser_v0;
    }
  }

  override getSupportedVersion(): number[] {
    return [0];
  }
}

const KeyParser_latest = (key: KeyStoreModel) => key;

const KeyParser_v0 = KeyParser_latest;
